import { Checkbox } from 'antd';
import styled from 'styled-components';
const CheckboxGroup = Checkbox.Group;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const VerticalCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  gap: 6px;
` as typeof CheckboxGroup;
